import { useState } from "react";
import { getToken } from "../services/auth"

export const useValidationImportNFCE = () => {
    const [importTableToNfce, setImportTableToNfce] = useState(false);
    const [isLoadingModalPrint, setIsLoadingModalPrint] = useState(false);

    const validationImportNFCe = () => JSON.parse(getToken('IMPORTDELIVERYORTABLE')) ? true : false

    const openImportNfce = () => setImportTableToNfce(validationImportNFCe())

    const closeImportNfce = () => setImportTableToNfce(false)

    const closeModalNFCE = () => {
        setIsLoadingModalPrint(false);
    }


    return{
        importTableToNfce, setImportTableToNfce, validationImportNFCe, openImportNfce,
        closeImportNfce, closeModalNFCE, isLoadingModalPrint, setIsLoadingModalPrint
    }
    
}